<script setup>

//Emits and props
defineProps({
  isAbsolute: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    :class="{
      [$style.wrapper]: true,
      [$style.absolute]: isAbsolute,
    }"
  >
    <slot />
  </div>
</template>

<style module lang="scss">
.wrapper {
  position: relative;
  &.absolute {
    position: absolute;
  }
}
</style>
